import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  facilitySelector: {
    marginBottom: 20,
    width: "100%"
  },
  header: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 16,
    borderTop: `1px solid ${theme.palette.text.hint}`,
    borderBottom: "1px solid #eee"
  },
  listItem: {
    height: 48,
    padding: "0 19px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #eee",
    color: "rgba(26, 26, 26, 1)",
    cursor: "pointer",
    textTransform: "capitalize",
    "&:last-child": {
      borderBottom: "none"
    }
  },
  radioButton: {
    color: "#1a1a1a",
    padding: 0
  },
  loader: {
    height: 192
  }
}));
